import api from './api';

// --- Reviewer Tool APIs ---

// Get all assigned requests for the current reviewer
export const getReviewerRequests = async () => {
    try {
        const response = await api.get('/reviewer/requests');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Respond to an assignment (accept/reject)
export const respondToAssignment = async (data) => {
    try {
        const response = await api.post('/reviewer/respond', data);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get active assignments for the reviewer (after accepting)
export const getReviewerAssignments = async () => {
    try {
        const response = await api.get('/reviewer/assignments');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// Submit a final review decision (accept/reject/modify)
export const submitReview = async (data) => {
    try {
        const response = await api.post('/reviewer/submit', data);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
